export default "__VITE_ASSET__a78e0ca2__"